import { FacetsFilterKeyModel } from '@/models/facets/facets';

export default class LORFacetItem {
    constructor(
        public name: string,
        public filterKey: FacetsFilterKeyModel = {} as FacetsFilterKeyModel,
        public isEditable: boolean = true,
        public isSelected: boolean = true,
        public items: any = [],
        public selectedItems: any = [],
    ) {}
}
